import {ItemsReducerState} from '../../../reducers/items/itemsReducer';
import {Guid} from '../../../model/guid';

export const createGetItemByIdFromItemsReducerState = (items: ItemsReducerState) => {
  return (itemId: Guid) => {
    const item = items.get(itemId);
    if (item) {
      return item;
    }
    throw Error('Item must exist');
  };
};

export const createGetMaybeItemByIdFromItemsReducerState = (items: ItemsReducerState) => {
  return (itemId: Guid) => items.get(itemId);
};
